import { Module } from 'vuex'

import { Contest } from '@/domain/entities/problem/contest'
import { Course } from '@/domain/entities/problem/course'
import { ProblemSearchModalStateType } from '@/domain/value_objects/problem/problemModalStateType'

interface ProblemSearchModalState {
  modalState: ProblemSearchModalStateType
  selectedCourse: Course
  selectedContestList: Contest[]
}

export const problemSearchModalStateModule = (): Module<ProblemSearchModalState, any> => {
  return {
    namespaced: true,
    state: {
      modalState: 'COURSE',
      selectedCourse: {
        id: 0,
        name: '',
        shortName: '',
        description: '',
        image: '',
        serial: 0,
        type: '',
        userScore: 0,
        maxScore: 0,
        progress: 0,
        numberOfTopics: null,
        topics: null
      },
      selectedContestList: []
    },
    mutations: {
      setModalState(state, modalState: ProblemSearchModalStateType) {
        state.modalState = modalState
      },
      setSelectedCourse(state, course: Course) {
        state.selectedCourse = course
      },
      setSelectedContestList(state, contest: Contest[]) {
        state.selectedContestList = contest
      }
    },
    actions: {},
    getters: {
      modalState: state => state.modalState,
      selectedCourse: state => state.selectedCourse,
      selectedContestList: state => state.selectedContestList
    }
  }
}
